import type { ChargebeeBundle } from 'modules/billing/lib/prices'

export const mergeInheritFeatures = (type: 'business' | 'enterprise', config: ChargebeeBundle) => {
  const bundleConfig = JSON.parse(JSON.stringify(config)) as ChargebeeBundle

  if (type === 'business') {
    return bundleConfig
  }

  bundleConfig.normalPlans = bundleConfig.normalPlans.map((plan) => ({
    ...plan,
    regions: {
      ...plan.regions,
      features: [...(plan.inheritFeatures?.regions?.features || []), ...plan.regions.features],
    },
  }))
  bundleConfig.extraAddon = bundleConfig.extraAddon
    ?.filter((addon) => addon.plan)
    .map((addon) => ({
      ...addon,
      plan: {
        ...addon.plan,
        regions: {
          ...addon.plan.regions,
          features: [
            ...(addon.plan.inheritFeatures?.regions?.features || []),
            ...addon.plan.regions.features,
          ],
        },
      },
    }))
  bundleConfig.extraAddons = bundleConfig.extraAddons?.map((addon) => ({
    ...addon,
    plan: {
      ...addon,
      regions: {
        ...addon.regions,
        features: [...(addon.inheritFeatures?.regions?.features || []), ...addon.regions.features],
      },
    },
  }))
  bundleConfig.corePlan = {
    ...bundleConfig.corePlan,
    regions: {
      ...bundleConfig.corePlan.regions,
      features: [
        ...(bundleConfig.corePlan.inheritFeatures?.regions?.features || []),
        ...bundleConfig.corePlan.regions.features,
      ],
    },
  }

  return bundleConfig
}
